var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "payment-create main-content" },
    [
      _c("div", { staticClass: "page-header" }, [
        _c("h3", { staticClass: "page-title" }, [
          _vm._v(
            "\n      " +
              _vm._s(_vm.$t("prepayments.view_po_prepayment")) +
              "\n    "
          ),
        ]),
        _vm._v(" "),
        _c("ol", { staticClass: "breadcrumb" }, [
          _c(
            "li",
            { staticClass: "breadcrumb-item" },
            [
              _c(
                "router-link",
                {
                  attrs: { slot: "item-title", to: "/super-admin/dashboard" },
                  slot: "item-title",
                },
                [_vm._v(_vm._s(_vm.$t("general.home")))]
              ),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "li",
            { staticClass: "breadcrumb-item" },
            [
              _c(
                "router-link",
                {
                  attrs: {
                    slot: "item-title",
                    to: "/super-admin/purchase-orders",
                  },
                  slot: "item-title",
                },
                [_vm._v(_vm._s(_vm.$tc("navigation.pos", 2)))]
              ),
            ],
            1
          ),
          _vm._v(" "),
          _c("li", { staticClass: "breadcrumb-item" }, [
            _vm._v(
              "\n        " +
                _vm._s(_vm.$t("prepayments.view_po_prepayment")) +
                "\n      "
            ),
          ]),
        ]),
      ]),
      _vm._v(" "),
      _c("SinglePurchaseOrderFinanceRow", {
        attrs: { fetchData: _vm.fetchData },
      }),
      _vm._v(" "),
      _c("SinglePrePaymentPOFinanceRequestRow", {
        attrs: { prepaymentRequest: _vm.prepaymentRequest },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }